import React, { useEffect } from 'react';
import { CardTrioCard } from '../../components/CardTrio/CardTrioCard';
import { getParagraph } from '../../components/componentHelpers';
import { ResourceHubBlock } from '../../components/RHBlock/RHBlock';
import { AnalyticsController } from '../../layout/Analytics';
export const ResourceHub = ({ paragraphs }) => {
    const blocks: any[] = [];

    useEffect(() => {
        AnalyticsController.pageView({
            pageType: `Resource Hub`,
        });
    }, []);

    let currentRhBlock: ResourceHubBlock | null = null;
    /** Break out the resourcehub blocks */
    for (const paragraph of paragraphs) {
        if (
            paragraph.type !== `paragraph__resource_hub_cards` &&
            paragraph.type !== `paragraph__resource_hub_cards_group_title`
        ) {
            if (currentRhBlock) {
                blocks.push(currentRhBlock);
                currentRhBlock = null;
            }
            blocks.push(paragraph);
        } else {
            if (
                paragraph.type === `paragraph__resource_hub_cards_group_title`
            ) {
                if (currentRhBlock) {
                    blocks.push(currentRhBlock);
                }
                currentRhBlock = new ResourceHubBlock();
                currentRhBlock.title = paragraph.field_resource_hub_group_title;
                currentRhBlock.subtitle =
                    paragraph.field_resource_hub_group_descrip?.value;
                currentRhBlock.id = paragraph.id;
            } else if (paragraph.type === `paragraph__resource_hub_cards`) {
                if (!currentRhBlock) continue;
                const card: CardTrioCard = {
                    id: paragraph.id,
                    title: paragraph.field_title,
                    description: paragraph.field_content?.value,
                    descriptionIsHtml: true,
                    image: paragraph.relationships?.field_image?.relationships
                        ?.field_media_image?.localFile,
                    imageAlt:
                        paragraph.relationships?.field_image?.field_media_image
                            ?.alt,
                    linkUrl: paragraph.field_link_to_content?.uri,
                    linkText: paragraph.field_link_to_content?.title,
                };
                currentRhBlock.cards.push(card);
            }
        }
    }

    const lastRhBlock = [...blocks].reverse().find((block) => {
        if (block.type === `rh_block`) {
            return block || null;
        }
    });
    if (lastRhBlock) {
        lastRhBlock.accent = true;
    }

    const renderedBlocks = blocks.map((block) => getParagraph(block, true));
    return <>{renderedBlocks}</>;
};
